// getUserListFromFeed.js
'use strict';
import { Collection, Set } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

const defaultSelectPath = [];
const defaultDataKey = '';
/**
 * Select user list from feed by
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {array} selectPath - select path.
 * @param {string} dataKey - select data key.
 * @return {array} The selected user list from feed.
 */
const getUserListFromFeed = createCachedSelector(
  state => state,
  (state, selectPath) => state.getIn(['lists', ...selectPath]),
  (state, selectPath, dataKey) => dataKey,
  (state, selectPath, dataKey, filterIds) => filterIds,
  (state, list, dataKey, filterIds = []) => {
    let result = undefined;
    if (list) {
      result = new Set(
        list
          .get(dataKey)
          ?.map(messageId => state.getIn(['messages', messageId, 'senderId']))
          ?.filter(userId => !filterIds.includes(userId))
      );
    }
    return result instanceof Collection ? result.toJS() : result;
  }
)(
  (state, selectPath = defaultSelectPath, dataKey = defaultDataKey) =>
    `${selectPath.join(':')}:${dataKey}`
);

export default getUserListFromFeed;
